// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { StyleSheet } from 'react-native';

import { GAME_COL_WIDTH, PLAYER_COL_WIDTH, TOTAL_COL_WIDTH } from './utils';
import appColors from '@/theme/colors';

export const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: 14,
    gap: 8,
    paddingBottom: 40,
    backgroundColor: '#011806',
  },
  headerCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: 'rgba(42,119,66,0.42)',
    backgroundColor: appColors.background.panel,
    padding: 10,
  },
  headerImage: {
    width: 100,
    height: 100,
    borderRadius: 12,
  },
  headerImagePlaceholder: {
    width: 100,
    height: 100,
    borderRadius: 12,
    backgroundColor: appColors.background.panelAlt,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.42)',
  },
  headerText: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  background: {
    flex: 1,
    backgroundColor: '#011806',
  },
  scroll: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
  },
  banner: {
    borderRadius: 12,
    backgroundColor: appColors.background.panel,
    borderWidth: 2,
    borderColor: 'rgba(42,119,66,0.42)',
    padding: 12,
  },
  bannerTitle: {
    fontSize: 20,
    fontWeight: '800',
    color: '#F5F5DC',
    letterSpacing: 0.6,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  bannerMeta: {
    color: '#F5F5DC',
    marginTop: 2,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  title: {
    fontSize: 20,
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  primaryButton: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.42)',
    backgroundColor: 'rgba(29,70,37,0.95)',
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignSelf: 'flex-start',
  },
  primaryText: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 12,
  },
  meta: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  error: {
    color: '#ff8c8c',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  waitingCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(148,203,116,0.62)',
    backgroundColor: 'rgba(17,62,24,0.86)',
    paddingHorizontal: 14,
    paddingVertical: 12,
    gap: 8,
  },
  waitingTitle: {
    color: '#F5F5DC',
    fontSize: 16,
    fontWeight: '800',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  waitingText: {
    color: '#F5F5DC',
    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundPickerCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.42)',
    backgroundColor: appColors.background.panel,
    padding: 10,
    gap: 8,
  },
  roundPickerTitle: {
    fontSize: 11,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    color: '#F5F5DC',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    textShadowColor: 'rgba(0,0,0,0.55)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  roundPicker: {
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.42)',
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 12,
    backgroundColor: 'rgba(29,70,37,0.95)',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  roundPickerText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#F5F5DC',
    flex: 1,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundPickerHint: {
    fontSize: 12,
    color: '#A1D493',
    fontWeight: '700',
    marginLeft: 12,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  tableCard: {
    borderRadius: 12,
    borderWidth: 2,
    borderColor: 'rgba(42,119,66,0.42)',
    backgroundColor: appColors.background.panel,
  },
  tableHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingTop: 8,
    backgroundColor: 'transparent',
  },
  resultsButtonRow: {
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    backgroundColor: 'transparent',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    marginHorizontal: 10,
    marginBottom: 10,
  },
  tableHeaderTitle: {
    fontSize: 12,
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  resultsButton: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 12,
    backgroundColor: 'rgba(29,70,37,0.95)',
  },
  resultsButtonText: {
    fontSize: 12,
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    textDecorationLine: 'none',
  },
  resultsActionButton: {
    minWidth: 0,
    width: 106,
    height: 34,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#A1D493',
    backgroundColor: '#A1D493',
    paddingHorizontal: 8,
  },
  resultsActionButtonText: {
    fontSize: 11,
    lineHeight: 13,
    fontWeight: '700',
  },
  roundSectionsCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.42)',
    backgroundColor: appColors.background.panel,
    padding: 10,
    gap: 10,
  },
  roundSectionsTitle: {
    fontSize: 11,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    color: '#F5F5DC',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    textShadowColor: 'rgba(0,0,0,0.55)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  roundSectionCard: {
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.36)',
    borderRadius: 10,
    backgroundColor: 'rgba(10,32,13,0.75)',
    padding: 8,
    gap: 8,
  },
  roundSectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  roundSectionTitle: {
    fontSize: 11,
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    flex: 1,
    textShadowColor: 'rgba(0,0,0,0.55)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  roundSectionMeta: {
    fontSize: 10,
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundSectionTable: {
    borderRadius: 8,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.28)',
  },
  roundSectionTableHeader: {
    flexDirection: 'row',
    backgroundColor: 'rgba(29,70,37,0.88)',
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  roundSectionHeaderText: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 11,
    textAlign: 'right',
    flex: 1,
  },
  roundSectionPlayerHeader: {
    textAlign: 'left',
  },
  roundSectionTableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 8,
  },
  roundSectionTableRowEven: {
    backgroundColor: appColors.background.panelAlt,
  },
  roundSectionTableRowOdd: {
    backgroundColor: 'rgba(11,38,16,0.82)',
  },
  roundSectionPlayerCell: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 13,
    flex: 1,
    textAlign: 'left',
  },
  roundSectionPointsCell: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 13,
    width: 72,
    textAlign: 'right',
  },
  roundSectionEmpty: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 11,
    paddingVertical: 10,
    paddingHorizontal: 8,
  },
  membersCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.42)',
    backgroundColor: appColors.background.panel,
    padding: 10,
    gap: 8,
  },
  membersTitle: {
    fontSize: 11,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    color: '#F5F5DC',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    textShadowColor: 'rgba(0,0,0,0.55)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  membersHint: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 11,
  },
  membersList: {
    gap: 6,
    backgroundColor: 'transparent',
  },
  memberRow: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.28)',
    paddingVertical: 8,
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  memberRowEven: {
    backgroundColor: appColors.background.panelAlt,
  },
  memberRowOdd: {
    backgroundColor: 'rgba(11,38,16,0.82)',
  },
  memberMain: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  memberName: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 14,
  },
  memberMeta: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 11,
  },
  membersEmpty: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: 11,
  },
  table: {
    paddingVertical: 6,
    marginLeft: 10,
    marginBottom: 12,
  },
  tableHeaderTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(29,70,37,0.88)',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  tableHeaderBottomRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(29,70,37,0.88)',
  },
  roundHeaderOffset: {
    width: PLAYER_COL_WIDTH + TOTAL_COL_WIDTH,
    height: '100%',
    backgroundColor: 'rgba(29,70,37,0.88)',
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: appColors.background.panelAlt,
  },
  rowEven: {
    backgroundColor: appColors.background.panelAlt,
  },
  rowOdd: {
    backgroundColor: 'rgba(11,38,16,0.82)',
  },
  cell: {
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.32)',
    fontSize: 11,
    textAlign: 'center',
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    backgroundColor: 'transparent',
  },
  playerCell: {
    width: PLAYER_COL_WIDTH,
    textAlign: 'left',
    fontWeight: '600',
    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  gameCell: {
    width: GAME_COL_WIDTH,
    fontSize: 10,
    textTransform: 'uppercase',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  totalCell: {
    width: TOTAL_COL_WIDTH,
    fontWeight: '900',
    fontSize: 13,
    color: '#F5F5DC',
    textShadowColor: 'rgba(0, 0, 0, 0.35)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  totalCellHeader: {
    backgroundColor: 'rgba(29,70,37,0.9)',
  },
  playerHeaderCell: {
    backgroundColor: 'rgba(29,70,37,0.9)',
  },
  gameHeaderCell: {
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.32)',
    paddingVertical: 6,
    paddingHorizontal: 4,
    backgroundColor: 'rgba(29,70,37,0.88)',
  },
  roundGroupHeaderCell: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  gameHeaderText: {
    fontSize: 11,
    textAlign: 'center',
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundHeaderCell: {
    backgroundColor: 'rgba(29,70,37,0.7)',
  },
  roundNumberText: {
    fontSize: 10,
    color: '#F5F5DC',
    fontWeight: '600',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundCell: {
    width: GAME_COL_WIDTH,
  },
  claimCell: {
    width: 86,
    alignItems: 'center',
    justifyContent: 'center',
  },
  claimButton: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.42)',
    backgroundColor: 'rgba(29,70,37,0.95)',
    paddingVertical: 3,
    paddingHorizontal: 8,
  },
  claimButtonDisabled: {
    opacity: 0.6,
  },
  claimButtonText: {
    fontSize: 11,
    color: '#F5F5DC',
    fontWeight: '700',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  gameRoundsRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  resultCell: {
    backgroundColor: 'transparent',
  },
  resultText: {
    color: '#F5F5DC',
    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundsCardTitle: {
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 6,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundRowLabel: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundsSummary: {
    marginTop: 4,
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  summaryList: {
    marginTop: 4,
  },
  summaryItem: {
    fontSize: 12,
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  graphWrap: {
    paddingVertical: 6,
    gap: 12,
  },
  graphLegend: {
    gap: 6,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  legendSwatch: {
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  legendLabel: {
    color: '#F5F5DC',
    fontSize: 12,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
  modalCard: {
    width: '92%',
    maxWidth: 520,
    borderRadius: 16,
    padding: 16,
    backgroundColor: appColors.background.panel,
    gap: 12,
  },
  modalTableCard: {
    maxWidth: 700,
  },
  roundPickerModalCard: {
    maxWidth: 520,
    maxHeight: '80%',
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  modalError: {
    color: '#fca5a5',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  modalButtonRow: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'flex-end',
    width: '100%',
    flexWrap: 'wrap',
  },
  modalActionButton: {
    width: 108,
    minWidth: 108,
    height: 34,
  },
  modalActionText: {
    fontSize: 11,
    fontWeight: '700',
    lineHeight: 13,
  },
  modalSecondaryButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 12,
    backgroundColor: '#1A3A20',
    minWidth: 96,
    alignItems: 'center',
  },
  modalSecondaryText: {
    color: '#F5F5DC',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  modalCloseButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 12,
    backgroundColor: '#A1D493',
    minWidth: 96,
    alignItems: 'center',
  },
  modalCloseText: {
    color: '#F5F5DC',
    fontWeight: '600',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundPickerOptions: {
    gap: 8,
    backgroundColor: 'transparent',
  },
  roundPickerOption: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.28)',
    paddingVertical: 10,
    paddingHorizontal: 10,
    backgroundColor: appColors.background.panelAlt,
  },
  roundPickerOptionTitle: {
    color: '#F5F5DC',
    fontSize: 14,
    fontWeight: '700',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  roundPickerOptionSubtitle: {
    color: '#F5F5DC',
    fontSize: 12,
    marginTop: 2,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  resultsTableRoundHeaderRow: {
    flexDirection: 'row',
    backgroundColor: 'rgba(29,70,37,0.88)',
  },
  resultsTableRoundHeaderCell: {
    paddingVertical: 6,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.32)',
    alignItems: 'center',
  },
  resultsTableRoundHeaderText: {
    color: '#F5F5DC',
    fontSize: 11,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  resultsTableHeaderRow: {
    flexDirection: 'row',
    backgroundColor: 'rgba(29,70,37,0.9)',
  },
  resultsTableRow: {
    flexDirection: 'row',
    backgroundColor: appColors.background.panelAlt,
  },
  resultsTableCell: {
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: 'rgba(42,119,66,0.32)',
    fontSize: 14,
    color: '#F5F5DC',
    textAlign: 'center',
    minWidth: 40,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  resultsTablePlayerCell: {
    width: 120,
    textAlign: 'left',
  },
  resultsTableHoleCell: {
    minWidth: 40,
  },
});
